module.exports = __webpack_public_path__ + "static/satvika-daf091e4537eaf791ed2980705762012.jpg";